import script from "./clubmasterAccordion.vue?vue&type=script&setup=true&lang=js"
export * from "./clubmasterAccordion.vue?vue&type=script&setup=true&lang=js"

import "./clubmasterAccordion.vue?vue&type=style&index=0&id=c3f0ddb4&scoped=true&lang=css"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3f0ddb4"]])

export default __exports__